import React from 'react';
import Icon from '../../../components/AppIcon';

const SocialProofSection = ({ activities }) => {
  const testimonials = [
    {
      name: "Sarah Johnson",
      role: "Impact Investor",
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop&crop=face",
      content: "Share Good has completely transformed how I approach charitable giving. The AI recommendations helped me discover causes I never knew existed, and seeing my real-time impact keeps me motivated to give more.",
      rating: 5
    },
    {
      name: "Michael Chen",
      role: "Corporate ESG Manager",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
      content: "Managing our company\'s ESG initiatives has never been easier. The platform\'s reporting features and transparent tracking make it simple to showcase our social impact to stakeholders.",
      rating: 5
    },
    {
      name: "Emily Rodriguez",
      role: "Community Organizer",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
      content: "The giving challenges feature brought our entire community together. We raised more in one month through Share Good than we did all last year through traditional fundraising events.",
      rating: 5
    }
  ];

  return (
    <section id="impact" className="py-16 md:py-24 bg-gradient-to-br from-orange-50 via-cream-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-teal-100 text-black px-4 py-2 rounded-full mb-4 text-sm font-medium">
            <Icon name="Heart" size={16} />
            <span>Community Impact</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">
            Join a Community of{' '}
            <span className="bg-gradient-to-r from-coral-500 to-orange-500 bg-clip-text text-transparent">
              Changemakers
            </span>
          </h2>
          <p className="text-xl text-black max-w-3xl mx-auto">
            See what others are accomplishing and get inspired by real stories of impact
          </p>
        </div>

        {/* Recent Activities Feed */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-black mb-6 text-center">Recent Community Activity</h3>
          <div className="max-w-2xl mx-auto space-y-4">
            {activities?.map((activity, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow border border-orange-100 animate-in slide-in-from-bottom"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-coral-500 to-orange-500 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                    {activity?.donor?.charAt(0)}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-center gap-2 mb-2">
                      <span className="font-semibold text-black">{activity?.donor}</span>
                      <span className="text-black">{activity?.action}</span>
                      <span className="font-medium text-black">{activity?.cause}</span>
                      {activity?.amount && (
                        <span className="inline-flex items-center space-x-1 bg-teal-100 text-black px-3 py-1 rounded-full text-sm font-medium">
                          <Icon name="DollarSign" size={14} />
                          <span>${activity?.amount}</span>
                        </span>
                      )}
                    </div>
                    <div className="text-sm text-black flex items-center">
                      <Icon name="Clock" size={14} className="mr-1" />
                      {activity?.timeAgo}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Testimonials */}
        <div>
          <h3 className="text-2xl font-bold text-black mb-8 text-center">What Our Community Says</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials?.map((testimonial, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-orange-100"
              >
                {/* Rating */}
                <div className="flex space-x-1 mb-4">
                  {[...Array(testimonial?.rating)]?.map((_, i) => (
                    <Icon key={i} name="Star" size={18} className="text-amber-400 fill-amber-400" />
                  ))}
                </div>

                {/* Content */}
                <p className="text-black mb-6 leading-relaxed italic">
                  "{testimonial?.content}"
                </p>

                {/* Author */}
                <div className="flex items-center space-x-4">
                  <img
                    src={testimonial?.image}
                    alt={`Portrait of ${testimonial?.name}`}
                    className="w-12 h-12 rounded-full object-cover border-2 border-coral-200"
                  />
                  <div>
                    <div className="font-semibold text-black">{testimonial?.name}</div>
                    <div className="text-sm text-black">{testimonial?.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Trust Badges */}
        <div className="mt-16 text-center">
          <p className="text-black mb-8 font-medium">Trusted by leading organizations and individuals worldwide</p>
          <div className="flex flex-wrap justify-center items-center gap-8 opacity-50">
            <div className="text-2xl font-bold text-black">501(c)(3) Verified</div>
            <div className="text-2xl font-bold text-black">BBB Accredited</div>
            <div className="text-2xl font-bold text-black">GuideStar Platinum</div>
            <div className="text-2xl font-bold text-black">Charity Navigator 4-Star</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;